import React from 'react';
import Relay from 'react-relay';

import SimpleInfiniteScroll from 'depop/components/SimpleInfiniteScroll';

import { ProductList } from 'depop/components/ProductList';


class FeaturedProducts extends React.PureComponent {
  props: {
    relay: Object,
    userRelations: Object,
    loadedMore: (numResults: number) => void,
  }

  loadMore = () => {
    const numResults = this.props.relay.variables.numResults + 24;

    this.props.relay.setVariables({
      numResults,
    });

    this.props.loadedMore && this.props.loadedMore(numResults);
  };

  render() {
    const { viewer } = this.props;
    const { products } = viewer.suggested;

    return (
      <SimpleInfiniteScroll
        loadMore={this.loadMore}
        hasMore={products.pageInfo.hasNextPage}>
        <ProductList
          from="browse"
          listName="Explore"
          products={products.edges.map(edge => edge.node)}
        />
      </SimpleInfiniteScroll>
    );
  }
}

export default Relay.createContainer(FeaturedProducts, {
  initialVariables: {
    numResults: null,
  },
  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        suggested {
          products(first: $numResults) {
            edges {
              node {
                ${ProductList.getFragment('products')}
              }
            }
            pageInfo {
              hasNextPage
            }
          }
        }
      }
    `,
  },
});



// WEBPACK FOOTER //
// ../src/client/apps/root/components/FeaturedProducts.js